import React, { useRef, useCallback } from 'react';
import classNames from 'classnames';
import { Tooltip } from '@deephaven/components';
import "./CommandHistoryItem.css";
import CommandHistoryItemTooltip from "./CommandHistoryItemTooltip.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var MAX_TRUNCATE_LENGTH = 512;
function CommandHistoryItem(_ref) {
  var item = _ref.item,
    language = _ref.language,
    _ref$isSelected = _ref.isSelected,
    isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected,
    commandHistoryStorage = _ref.commandHistoryStorage;
  var previewText = item.name.substring(0, MAX_TRUNCATE_LENGTH);
  var tooltip = useRef(null);
  var handleUpdate = useCallback(() => {
    var _tooltip$current;
    (_tooltip$current = tooltip.current) === null || _tooltip$current === void 0 || _tooltip$current.update();
  }, [tooltip]);
  return /*#__PURE__*/_jsxs("div", {
    className: classNames('command-history-item', {
      selected: isSelected
    }),
    children: [previewText, /*#__PURE__*/_jsx(Tooltip, {
      ref: tooltip,
      interactive: true,
      options: {
        placement: 'left',
        modifiers: {
          preventOverflow: {
            enabled: true,
            boundariesElement: 'viewport',
            order: 825 // modify order so boundary is enforced at end of popper calcs
          }
        }
      },
      popperClassName: "command-history-item-popper",
      children: /*#__PURE__*/_jsx(CommandHistoryItemTooltip, {
        item: item,
        language: language,
        onUpdate: handleUpdate,
        commandHistoryStorage: commandHistoryStorage
      })
    })]
  });
}
export default CommandHistoryItem;
//# sourceMappingURL=CommandHistoryItem.js.map